import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import {IconoirXmark, IconoirCheck} from '@ey-xd/motif-icon';

import {labels} from '../../../util/utils';
import MotifIcon from '../BaseComponentWrappers/MotifIcon';

function CanvasFormInputButtons({className, value, onAccept, onCancel}) {
	const renderCancel = () => {
		const props = {
			onClick: (evt) => onCancel && onCancel(value, evt),
			src: IconoirXmark,
			title: labels.cancelLabel,
			className: 'cancel-icon'
		};
		return <MotifIcon {...props} />;
	};

	const renderAccept = () => {
		const props = {
			onClick: (evt) => onAccept && onAccept(value, evt),
			src: IconoirCheck,
			title: labels.saveLabel,
			variant: 'ghost',
			className: 'accept-icon'
		};
		return <MotifIcon {...props} />;
	};

	return (
		<StyledConfirmInputIcons className={`StyledConfirmInputIcons ${className}`}>
			{renderAccept()}
			{renderCancel()}
		</StyledConfirmInputIcons>
	);
}

CanvasFormInputButtons.propTypes = {
	className: PropTypes.string,
	value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	onAccept: PropTypes.func.isRequired,
	onCancel: PropTypes.func
};

CanvasFormInputButtons.defaultProps = {
	className: 'canvas-form-input-buttons'
};

export default CanvasFormInputButtons;

const StyledConfirmInputIcons = styled.section`
	display: flex;
	align-items: center;
	justify-content: center;
	gap: var(--px-8);
	z-index: 1;

	.motif-icon {
		display: flex;
		align-items: center;
		cursor: pointer;
		svg {
			width: var(--px-20);
			height: var(--px-20);
		}
		&.accept-icon {
			svg {
				color: var(--neutrals-700);
			}
		}
		&.cancel-icon {
			svg {
				color: var(--neutrals-700);
			}
		}
	}
`;
